<template>
  <v-container fluid>
    <v-card class="leftBlock">
      <v-card class="mb-2">
        <v-card-title primary-title>
          <span class="headline mb-0">財務実績帳票</span>
        </v-card-title>
      </v-card>
      <v-card class="mb-2">
        <v-card-title primary-title>
          <span class="headline mb-0">納品書データ</span>
        </v-card-title>

        <v-card-actions>
          <v-btn @click="eiajExcel('', 'archive', eiajArchiveMonth)"
            >出力</v-btn
          >
        </v-card-actions>

        <v-form v-model="eiajValid">
          <v-container fluid>
            <v-layout row wrap>
              <v-flex md3 sm6 xs12>
                <!-- :max="query.to" -->
                <date-picker
                  :rules="[(v) => !!v || ` 売上計上日 is required`]"
                  label="売上計上日"
                  style="padding: 8px"
                  type="month"
                  v-model="eiajArchiveMonth"
                ></date-picker>
              </v-flex>
            </v-layout>
          </v-container>
        </v-form>
      </v-card>
      <v-card class="mb-2">
        <v-card-title primary-title>
          <span class="headline mb-0">外貨払い_Jusda用</span>
        </v-card-title>

        <v-card-actions>
          <v-btn
            @click="
              foreignExchange('', 'archive/one', foreignArchiveExchangeMonth)
            "
            ><span style="">出力（1~月末）</span><span style="">「履歴1~20日」</span></v-btn
          >
          <v-btn
            @click="
              foreignExchange('', 'archive/two', foreignArchiveExchangeMonth)
            "
            ><span style="">出力</span><span style="">「履歴21~月末」</span></v-btn
          >
        </v-card-actions>

        <v-form>
          <v-container fluid>
            <v-layout row wrap>
              <v-flex md3 sm6 xs12>
                <!-- :max="query.to" -->
                <date-picker
                  :rules="[(v) => !!v || ` ETA date is required`]"
                  label="ETA"
                  style="padding: 8px"
                  type="month"
                  v-model="foreignArchiveExchangeMonth"
                ></date-picker>
              </v-flex>
            </v-layout>
          </v-container>
        </v-form>
      </v-card>

      <v-card class="mb-2">
        <v-card-title primary-title>
          <span class="headline mb-0">海外請求データ</span>
        </v-card-title>

        <v-card-actions>
          <v-btn
            @click="
              overseasProviderExcel('', 'archive', overseasProviderArchiveMonth)
            "
            >出力</v-btn
          >
        </v-card-actions>

        <v-form v-model="overseasProviderValid">
          <v-container fluid>
            <v-layout row wrap>
              <v-flex md3 sm6 xs12>
                <!-- :max="query.to" -->
                <date-picker
                  :rules="[(v) => !!v || ` 売上計上日 is required`]"
                  label="売上計上日"
                  style="padding: 8px"
                  type="month"
                  v-model="overseasProviderArchiveMonth"
                ></date-picker>
              </v-flex>
            </v-layout>
          </v-container>
        </v-form>
      </v-card>

      <v-card class="mb-2">
        <v-card-title primary-title>
          <span class="headline mb-0">無償インボイスデータ</span>
        </v-card-title>

        <v-card-actions>
          <v-btn @click="unPaidExcel('', 'archive', unPaidArchiveMonth)"
            >出力</v-btn
          >
        </v-card-actions>

        <v-form v-model="eiajValid">
          <v-container fluid>
            <v-layout row wrap>
              <v-flex md3 sm6 xs12>
                <date-picker
                  :rules="[(v) => !!v || ` 売上計上日 is required`]"
                  label="売上計上日"
                  style="padding: 8px"
                  type="month"
                  v-model="unPaidArchiveMonth"
                ></date-picker>
              </v-flex>
            </v-layout>
          </v-container>
        </v-form>
      </v-card>

      <v-card class="mb-2">
        <v-card-title primary-title>
          <span class="headline mb-0">乙仲実績データ（年月）</span>
        </v-card-title>

        <v-card-actions>
          <!-- <v-btn @click="supplierMonthExcel1">出力1</v-btn> -->
          <v-btn @click="supplierMonthExcel2">出力</v-btn>
        </v-card-actions>

        <v-form v-model="supplierMonthValid">
          <v-container fluid>
            <v-layout row wrap>
              <v-flex md6 sm6 xs12>
                <v-layout row wrap>
                  <v-flex md6 pr-2 sm6 xs6>
                    <!-- :max="query.to" -->
                    <date-picker
                      :rules="[(v) => !!v || ` 諸掛費用承認日 is required`]"
                      label="諸掛費用承認日起"
                      style="padding: 8px"
                      type="month"
                      v-model="supplierMonthStart"
                    ></date-picker>
                  </v-flex>
                  <v-flex md6 pl-2 sm6 xs6>
                    <date-picker
                      :min="supplierMonthStart"
                      :rules="[(v) => !!v || ` 諸掛費用承認日 is required`]"
                      label="~"
                      style="padding: 8px"
                      type="month"
                      v-model="supplierMonthEnd"
                    ></date-picker>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-container>
        </v-form>
      </v-card>

      <v-card class="mb-2">
        <v-card-title primary-title>
          <span class="headline mb-0">その他諸掛報告用</span>
        </v-card-title>

        <v-card-actions>
          <v-btn @click="otherLocalChargeExcel">出力</v-btn>
        </v-card-actions>

        <v-form v-model="otherLocalValid">
          <v-container fluid>
            <v-layout row wrap>
              <v-flex md3 sm6 xs12>
                <!-- :max="query.to" -->
                <date-picker
                  :rules="[(v) => !!v || ` 年月 date is required`]"
                  label="年月"
                  style="padding: 8px"
                  type="month"
                  v-model="otherLocalMonth"
                ></date-picker>
              </v-flex>
            </v-layout>
          </v-container>
        </v-form>
      </v-card>
    </v-card>
    <v-card class="rightBlock">
      <v-card class="mb-2">
        <v-card-title primary-title>
          <span class="headline mb-0">速報帳票</span>
        </v-card-title>
      </v-card>
      <v-card class="mb-2">
        <v-card-title primary-title>
          <span class="headline mb-0">納品書データ</span>
        </v-card-title>

        <v-card-actions>
          <v-btn @click="eiajExcel('', 'business', eiajMonth)">出力</v-btn>
        </v-card-actions>

        <v-form v-model="eiajValid">
          <v-container fluid>
            <v-layout row wrap>
              <v-flex md3 sm6 xs12>
                <!-- :max="query.to" -->
                <date-picker
                  :rules="[(v) => !!v || ` 売上計上日 is required`]"
                  label="売上計上日"
                  style="padding: 8px"
                  type="month"
                  v-model="eiajMonth"
                ></date-picker>
              </v-flex>
            </v-layout>
          </v-container>
        </v-form>
      </v-card>
      <v-card class="mb-2">
        <v-card-title primary-title>
          <span class="headline mb-0">外貨払い_Jusda用</span>
        </v-card-title>

        <v-card-actions>
          <v-btn @click="foreignExchange('', 'business', foreignExchangeMonth)"
            >出力</v-btn
          >
        </v-card-actions>

        <v-form>
          <v-container fluid>
            <v-layout row wrap>
              <v-flex md3 sm6 xs12>
                <!-- :max="query.to" -->
                <date-picker
                  :rules="[(v) => !!v || ` ETA date is required`]"
                  label="ETA"
                  style="padding: 8px"
                  type="month"
                  v-model="foreignExchangeMonth"
                ></date-picker>
              </v-flex>
            </v-layout>
          </v-container>
        </v-form>
      </v-card>

      <v-card class="mb-2">
        <v-card-title primary-title>
          <span class="headline mb-0">海外請求データ</span>
        </v-card-title>

        <v-card-actions>
          <v-btn
            @click="
              overseasProviderExcel('', 'business', overseasProviderMonth)
            "
            >出力</v-btn
          >
        </v-card-actions>

        <v-form v-model="overseasProviderValid">
          <v-container fluid>
            <v-layout row wrap>
              <v-flex md3 sm6 xs12>
                <!-- :max="query.to" -->
                <date-picker
                  :rules="[(v) => !!v || ` 売上計上日 is required`]"
                  label="売上計上日"
                  style="padding: 8px"
                  type="month"
                  v-model="overseasProviderMonth"
                ></date-picker>
              </v-flex>
            </v-layout>
          </v-container>
        </v-form>
      </v-card>

      <v-card class="mb-2">
        <v-card-title primary-title>
          <span class="headline mb-0">無償インボイスデータ</span>
        </v-card-title>

        <v-card-actions>
          <v-btn @click="unPaidExcel('', 'business', unPaidBusinessMonth)"
            >出力</v-btn
          >
        </v-card-actions>

        <v-form v-model="eiajValid">
          <v-container fluid>
            <v-layout row wrap>
              <v-flex md3 sm6 xs12>
                <!-- :max="query.to" -->
                <date-picker
                  :rules="[(v) => !!v || ` 売上計上日 is required`]"
                  label="売上計上日"
                  style="padding: 8px"
                  type="month"
                  v-model="unPaidBusinessMonth"
                ></date-picker>
              </v-flex>
            </v-layout>
          </v-container>
        </v-form>
      </v-card>
    </v-card>
  </v-container>
</template>
<script>
export default {
  data() {
    return {
      eiajValid: true,
      eiajMonth: null,
      eiajArchiveMonth: null,

      overseasProviderValid: true,
      overseasProviderMonth: null,
      overseasProviderArchiveMonth: null,

      unPaidArchiveMonth: null,
      unPaidBusinessMonth: null,
      foreignExchangeMonth: null,
      foreignArchiveExchangeMonth: null,
      supplierMonthValid: true,
      supplierMonthStart: null,
      supplierMonthEnd: null,
      otherLocalValid: true,
      otherLocalMonth: null,
    }
  },
  methods: {
    eiajExcel(root, path, month) {
      this.$download(`${root}/reports/drsumEiaj/${path}?month=${month}`)
    },
    overseasProviderExcel(root, path, month) {
      this.$download(
        `${root}/reports/drsum-overseas-provider/${path}?month=${month}`
      )
    },
    foreignExchange(root, path, month) {
      this.$download(`${root}/reports/drsumForeign/${path}/?month=${month}`)
    },
    unPaidExcel(root, path, month) {
      this.$download(`${root}/reports/drsumUnPaid/${path}/?month=${month}`)
    },
    supplierMonthExcel1() {
      this.$download(
        `/reports/supplier1?startMonth=${this.supplierMonthStart}&endMonth=${this.supplierMonthEnd}`
      )
    },
    supplierMonthExcel2() {
      this.$download(
        `arap/reports/drsumSupplier/archive?startMonth=${this.supplierMonthStart}&endMonth=${this.supplierMonthEnd}`
      )
    },
    otherLocalChargeExcel() {
      if (this.otherLocalMonth != null) {
        this.$download(
          `/reports/V4/other-local-charges?yearMonth=${this.otherLocalMonth.replace(
            '-',
            ''
          )}`
        )
      } else {
        this.$message(
          this.$t('app.messages.errors.title'),
          '年と月を選ぶ必要があります'
        )
      }
    },
  },
}
</script>
<style scoped>
.leftBlock {
  display: inline-flex;
  flex-direction: column;
  width: 50%;
}

.rightBlock {
  display: inline-flex;
  flex-direction: column;
  width: 50%;
}
</style>
